import React from 'react';
import { cn } from '@/lib/utils';
import { Button } from '../button';
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
	TooltipProvider,
} from '../tooltip';

const IconButton = React.forwardRef(
	(
		{
			onClick,
			selected,
			className,
			disabled,
			toolTipTitle,
			toolTipSide,
			variant = 'ghost',
			toolTipClassName,
			toolTipAlign,
			type = 'button',
			// Not a button attribute (AIEnhanceButton passes it).
			loading: _loading,
			...props
		},
		ref
	) => {
		return (
			<TooltipProvider>
				<Tooltip delayDuration={0}>
					<TooltipTrigger asChild>
						<Button
							// What a Radix trigger wrapping this passes (aria-haspopup,
							// aria-expanded, data-state, its pointer and key handlers)
							// reaches the button. The props below still win.
							{...props}
							type={type}
							variant={selected ? 'default' : variant}
							size="icon"
							onClick={onClick}
							className={cn(disabled && 'opacity-30', className)}
							disabled={disabled}
							style={props.style}
							ref={ref}
							data-testid={props['data-testid']}
							data-onboarding={props['data-onboarding']}
							// The tooltip only shows with a mouse; VoiceOver reads its text as the name.
							aria-label={
								props['aria-label'] ??
								(typeof toolTipTitle === 'string' ? toolTipTitle : undefined)
							}
							aria-pressed={props['aria-pressed']}
						>
							{props.children}
						</Button>
					</TooltipTrigger>
					{toolTipTitle && (
						<TooltipContent
							align={toolTipAlign}
							side={toolTipSide}
							className={toolTipClassName}
						>
							{toolTipTitle}
						</TooltipContent>
					)}
				</Tooltip>
			</TooltipProvider>
		);
	}
);

export { IconButton };
